import { NavLink } from "react-router-dom";
import "./Header.css";

const Header = () => {
    return (
        <header className="site-header">
            <div className="header-container">
                <NavLink to="/categories" className="header-logo">
                    FACTURA FLAT
                </NavLink>

                <nav className="header-nav">
                    <NavLink to="/categories" className="header-link">
                        Каталог
                    </NavLink>
                    <NavLink to="/payment" className="header-link">
                        Оплата и доставка
                    </NavLink>
                    <NavLink to="/about" className="header-link">
                        О нас
                    </NavLink>
                    <NavLink to="/cart" className="header-link">
                        Корзина
                    </NavLink>
                </nav>
            </div>
        </header>
    );
};

export default Header;
